import {InputTypes} from "../../data-parsing/InputTypes";

export function buildColDefs(dataTemplate) {
    let i = 0;
    let colDefs = [];

    //Extra column for save button
    colDefs.push({
        name: "save",
        visibleName: "",
        type: InputTypes.SAVE,
        orderable: false,
        className: "editButtonColumn",
        targets: i++
    });
    for (const [key, value] of Object.entries(dataTemplate)) {
        if(!value.hidden && key !== "toString") {
            let newColDef = {}
            newColDef = {
                name: key,
                type: value.type,
                metadata: value,
                targets: i++
            };
            colDefs.push(newColDef);
        }
    }
    //Extra column for delete button
    colDefs.push({
        name: "delete",
        visibleName: "",
        type: InputTypes.DELETE,
        orderable: false,
        targets: i++
    });
    return colDefs;
}